'use server';

import type { SavedMaze } from '../types';

export async function getSavedMaze(mazeId: string): Promise<SavedMaze | null> {
  const { getSavedMazeRepository } = await import('../repositories');
  const repo = getSavedMazeRepository();
  try {
    return await repo.getById(mazeId);
  } catch {
    return null;
  }
}
